import ajax from '../../lib/ajax';
import {Store,Module,ActionContext} from 'vuex'
interface projectState{
    fundsCategory:any,
    fundsSource:any,
    completionWay:any,
    nature:any,
    professionalNature:any,
    projectCatalog:any,
    allArea:any,
    bearerUnitId:any,
    externalUnit:any,
    bearerOrgId:any,
    allDictionary:any,
    allDictionaryStatus:boolean,
    allDictionaryGroup:any,
    projectId:any,
    projectName:any,
    projectStatus:any,
    userList:any,
    researchProjectCatalog:any,
    userLeaders:any,
    majorFields:any,
    allPersons:any,
    bussinessArea:any,
    bearerOrgAll:any,
    contractBelongOrg:any,
    allPersonNoPermission:any,
    allSecondOrganization:any,
    assignSecondOrganization:any
}
class projectStore implements Module<projectState,any>{
    namespaced=true;
    state = {
        fundsCategory: [],
        fundsSource: [],
        completionWay: [],
        nature: [],
        professionalNature: [],
        projectCatalog: [],
        bearerUnitId: [],
        externalUnit: [],
        bearerOrgId: [],
        allArea: [],
        allDictionary: [],
        allDictionaryStatus: false,
        allDictionaryGroup: [],
        projectId: '',
        projectName: '',
        projectStatus: '',
        userList: [],
        researchProjectCatalog: [],
        userLeaders: [],
        majorFields: [],
        allPersons: [],
        bussinessArea: [],
        bearerOrgAll: [],
        contractBelongOrg: [],
        allPersonNoPermission: [],
        allSecondOrganization: [],
        assignSecondOrganization:[]
    }
    mutations:any = {
        setProjectId(state:any, id:any) {
            state.projectId = id;
        },
        setProjectName(state:any, name:any) {
            state.projectName = name;
        },
        setProjectStatus(state:any, status:any) {
            state.projectStatus = status;
        }
    }
    actions = {
        //获取资金类别数据
        async GetFundsCategory(content:ActionContext<projectState,any>) {
            if(content.state.fundsCategory.length == 0){
                content.state.fundsCategory = (await ajax.get('/api/services/app/Dictionary/GetFundsCategoryAsync')).data.result.map((item:any) => {
                    return { label: item.displayName, value: item.id}
                })
            }
        },
        //获取资金来源数据
        async GetFundsSource(content:ActionContext<projectState,any>) {
            if(content.state.fundsSource.length == 0){
                content.state.fundsSource = (await ajax.get('/api/services/app/Dictionary/GetFundsSourceAsync')).data.result.map((item:any) => {
                    return { label: item.displayName, value: item.id}
                })
            }
        },
        //获取项目完成方式数据
        async GetProjectCompletionWay(content:ActionContext<projectState,any>) {
            if(content.state.completionWay.length == 0){
                content.state.completionWay = (await ajax.get('/api/services/app/Dictionary/GetProjectCompletionWayAsync')).data.result.map((item:any) => {
                    return { label: item.displayName, value: item.id}
                })
            }
        },
        //获取项目性质数据
        async GetProjectNature(content:ActionContext<projectState,any>) {
            if(content.state.nature.length == 0){
                content.state.nature = (await ajax.get('/api/services/app/Dictionary/GetProjectNatureAsync')).data.result.map((item:any) => {
                    return { label: item.displayName, value: item.id}
                })
            }
        },
        //获取项目类别数据
        async GetAllProjectCatalog(content:ActionContext<projectState,any>) {
            if(content.state.projectCatalog.length == 0){
                content.state.projectCatalog = (await ajax.get('/api/services/app/ProjectManager/GetAllProjectCatalogAsync')).data.result.map((item:any) => {
                    return { label: item.catalogName, value: item.id}
                })
            }
        },
        //获取科研项目类别
        async GetResearchProjectCatalog(content:ActionContext<projectState,any>) {
            if(content.state.researchProjectCatalog.length == 0){
                content.state.researchProjectCatalog = (await ajax.get('/api/services/app/ResearchProject/GetAllCatalog')).data.result.items.map((item:any) => {
                    return { label: item.catalogName, value: item.id}
                })
            }
        },
        //获取项目专业性质数据
        async GetProjectProfessionalNature(content:ActionContext<projectState,any>) {
            if(content.state.professionalNature.length == 0){
                content.state.professionalNature = (await ajax.get('/api/services/app/Dictionary/GetProjectProfessionalNatureAsync')).data.result.map((item:any) => {
                    return { label: item.displayName, value: item.id}
                })
            }
        },        
        //获取单位数据
        async GetbearerUnit(content:ActionContext<projectState,any>) {
            if(content.state.bearerUnitId.length == 0){
                content.state.bearerUnitId = (await ajax.get('/api/services/app/Unit/GetAll?MaxResultCount=100')).data.result.map((item:any) => {
                    return { label: item.unitName, value: item.id,isRevoked:item.isRevoked}
                })
            }
        },
        //获取外协单位数据
        async GetAllExternalUnit(content:ActionContext<projectState,any>) {
            if(content.state.externalUnit.length == 0){
                console.log(await ajax.get('/api/services/app/Contract/GetAllExternalUnitNotPagingAsync'))
                content.state.externalUnit = (await ajax.get('/api/services/app/Contract/GetAllExternalUnitNotPagingAsync')).data.result.map((item:any) => {
                    return { label: item.unitName, value: item.id}
                })
            }
        },
        //获取项目承担部门数据
        async GetbearerOrg(content:ActionContext<projectState,any>) {
            if(content.state.bearerOrgId.length == 0){
                content.state.bearerOrgId = (await ajax.get('/api/services/app/Organization/GetBearOrganization')).data.result.map((item:any) => {
                    return { label: item.displayName, value: item.id}
                })
            }
        },
        //获取合同所属部门
        async GetContractBelongOrg(content:ActionContext<projectState,any>) {
            if(content.state.contractBelongOrg.length == 0){
                content.state.contractBelongOrg = (await ajax.get('/api/services/app/Organization/GetContractBelongOrganization')).data.result.map((item:any) => {
                    return { label: item.displayName, value: item.id,isRevoked:item.isRevoked}
                })
            }
        },        
        //获取所有部门数据
        async GetAllOrganization(content:ActionContext<projectState,any>) {
            if(content.state.bearerOrgAll.length == 0){
                content.state.bearerOrgAll = (await ajax.get('/api/services/app/Organization/GetAllOrganizationAsync')).data.result.map((item:any) => {
                    return { label: item.displayName, value: item.id}
                })
            }
        },
        //获取地区数据
        async GetArea(content:any) {
            if(content.state.allArea.length == 0){
                content.state.allArea = (await ajax.get('/api/services/app/Region/GetAllProvinceRegions')).data.result;
            }
        },
        //获取所有词典
        async GetAllDictionary(content:ActionContext<projectState,any>){
            if(content.state.allDictionary.length > 0) return;
            content.state.allDictionary = (await ajax.get('/api/services/app/Setting/GetAllDictionary')).data.result;
        },
        //获取所有字典分组
        async GetAllDictionaryGroup(content:ActionContext<projectState,any>){
            if(content.state.allDictionaryGroup.length > 0) return;
            content.state.allDictionaryGroup = (await ajax.get('/api/services/app/SysBaseData/GetAllCatalogAsync')).data.result.items;
        },
        //获取用户列表
        async GetAllUser(content:ActionContext<projectState,any>){
            if(content.state.userList.length == 0){
                content.state.userList = (await ajax.get('/api/services/app/User/GetAllPersonAsync')).data.result.items.map((item:any) => {
                    return { label: item.name, value: item.id}
                })
            }
        },
        //获取当前用户部门领导
        async GetLeaders(content:ActionContext<projectState,any>){
            if(content.state.userLeaders.length == 0){
                content.state.userLeaders = (await ajax.get('/api/services/app/User/GetLeadersAsync')).data.result.items.map((item:any) => {
                    return { label: item.name, value: item.id}
                })
            }
        },
        async GetLeadersAsync(content:ActionContext<projectState,any>,payload:any){
            if(content.state.userLeaders.length == 0){
                content.state.userLeaders = (await ajax.get('/api/services/app/User/GetLeadersByDepIdAsync?id='+payload)).data.result.items.map((item:any) => {
                    return { label: item.name, value: item.id}
                })
            }
        },
        //获取专业方向
        async GetAllMajorField(content:ActionContext<projectState,any>){
        	if(content.state.majorFields.length == 0){
                content.state.majorFields = (await ajax.get('/api/services/app/Expert/GetAllMajorFieldAsync')).data.result.map((item:any) => {
                    return { label: item.majorFieldName, value: item.id, code: item.majorFieldCode }
                })
            }
        },
        //查询所有人员信息
        async GetAllPersons(content:ActionContext<projectState,any>){
        	if(content.state.allPersons.length == 0){
                content.state.allPersons = (await ajax.get('/api/services/app/User/GetAllPersonAsync')).data.result.items.map((item:any) => {
                    return { label: item.name, value: item.id, userName: item.userName, phoneNumber: item.phoneNumber }
                })
            }
        },
        //查询一级业务领域
        async GetBussinessAreaAsync(content:ActionContext<projectState,any>){
        	if(content.state.bussinessArea.length == 0){
                content.state.bussinessArea = (await ajax.get('/api/services/app/SysBaseData/GetBussinessAreaAsync')).data.result.items;
            }
        },
        //合同签订人查询特殊接口
        async GetAllPersonNoPermission(content:ActionContext<projectState,any>){
        	if(content.state.allPersonNoPermission.length == 0){
                content.state.allPersonNoPermission = (await ajax.get('/api/services/app/User/GetAllPersonNoPermissionAsync')).data.result.items.map((item:any) => {
                    return { label: item.name, value: item.id, userName: item.userName, phoneNumber: item.phoneNumber }
                })
            }
        },
        //获取所有二级部门
        async GetAllSecondOrganization(content:ActionContext<projectState,any>){
        	if(content.state.allSecondOrganization.length == 0){
                content.state.allSecondOrganization = (await ajax.get('/api/services/app/Organization/GetAllSecondOrganizationAsync')).data.result;
            }
        },
        //获取以及部门下面的二级部门
        async GetAssignSecondOrganization(content:ActionContext<projectState,any>,payload:any){
            content.state.assignSecondOrganization = (await ajax.get('/api/services/app/Organization/GetAllChildrenOrganizationByParentIdAsync?id='+payload)).data.result;
        }, 
    }
}
const project = new projectStore();
export default project;